import { render } from "./customFields.vue?vue&type=template&id=cbabae1a&scoped=true&ts=true"
import script from "./customFields.vue?vue&type=script&lang=ts"
export * from "./customFields.vue?vue&type=script&lang=ts"

import "./customFields.vue?vue&type=style&index=0&id=cbabae1a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cbabae1a"]])

export default __exports__